var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showStatic
    ? _c(
        "section",
        { staticClass: "products__static", class: [_vm.bgColorClass] },
        [
          _c(
            "div",
            { staticClass: "products__static-content" },
            [
              _c("figure", { staticClass: "products__static-illustration" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "media-container media-container--contain media-container--square",
                  },
                  [
                    _c("img", {
                      staticClass: "products__static-illustration-element",
                      attrs: {
                        src: _vm.illustrationPath,
                        alt: "Illustration",
                        loading: "eager",
                      },
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _vm.title
                ? _c("h2", {
                    staticClass: "products__static-title",
                    domProps: { innerHTML: _vm._s(_vm.title) },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.text
                ? _c("div", {
                    staticClass: "products__static-text",
                    domProps: { innerHTML: _vm._s(_vm.text) },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.linkText && _vm.linkUrl
                ? _c("Button", {
                    staticClass: "products__static-button",
                    attrs: {
                      level: "inverted",
                      type: "button",
                      text: _vm.linkText,
                      href: _vm.linkUrl,
                      target: "_blank",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }